import { FC } from 'react';
import RadioGroup, { RadioGroupProps } from 'components/RadioGroup';

type Props = Omit<RadioGroupProps, 'options'>;

const options = [
  { value: 'SOLO', label: 'Grupė' },
  { value: 'GROUP', label: 'Individualus' },
];

const ServiceTypeSelect: FC<Props> = props => (
  <RadioGroup options={options} {...props} />
);

export default ServiceTypeSelect;
